import animation from './animation'
import colors from './colors'
import fonts from './fonts'
import measures from './measures'
import viewportType from './viewportType'
import zIndex from './zIndex'

const defaultTheme = {
  animation,
  colors,
  fonts,
  measures,
  viewportType,
  zIndex,
}

type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>
}

export type Theme = typeof defaultTheme
export type ThemeOverride = RecursivePartial<Theme>
export default defaultTheme
